import { useState } from "react";
import ReactStars from "react-rating-stars-component";
import addcart from "../images/add-cart.svg";
import { symbole } from "./commonData";
import cart from "../images/cart.svg";
import "./cardCommon.css";
import ModalPortal from "./ModalPortal";
const ProductCardCommon = ({
  item,
  index,
  addToWish,
  navigate,
  wish,
  prodcompare,
  view,
  addcart,
}) => {
  const price = parseInt(item?.price);
  const currentPrice = parseInt(item?.current_price);
  const off = price > 0 ? Math.round((1 - currentPrice / price) * 100) : 0;

  // ✅ State for size, color, quantity, and modal visibility
  const [showOptions, setShowOptions] = useState(false);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [quantity, setQuantity] = useState(1);

  const sizes = item?.size || [];
  const colors = item?.color || []; // array of objects e.g. [{_id, title}]
  const maxQty = item?.quantity || 10;

  const handleBuyNow = () => {
    // Show options if size/color available
    if ((sizes.length > 0 || colors.length > 0) && !showOptions) {
      setShowOptions(true);
    } else {
      navigate("/checkout", {
        state: { product: { ...item, quantity:quantity, size: selectedSize || null,
          color: selectedColor || null, },quantity },
      });
    }
  };

  const handleProceed = () => {
    if ((sizes.length > 0 && !selectedSize) || (colors.length > 0 && !selectedColor)) {
      alert("Please select all required options before proceeding");
      return;
    }

    navigate("/checkout", {
      state: {
        product: {
          ...item,
          size: selectedSize || null,
          color: selectedColor || null,
          quantity,
        },
      },
    });
  };

  return (
    <div key={index} className="col-12">
      <div className="product-card position-relative h-100 mb-0">
        {/* Wishlist */}
        {/* <div className="wishlist-icon position-absolute">
          <button className="border-0 bg-transparent">
            <img
              src={wish}
              alt="wishlist"
              onClick={() => addToWish(item?._id)}
            />
          </button>
          
        </div> */}
        

        {/* Product Images */}
        <div className="product-image">
          {[0, 1].map(
            (i) =>
              item?.images?.[i]?.url && (
                <img
                  key={i}
                  src={item.images[i].url}
                  className="img-fluid"
                  alt="product"
                  style={{ height: "100%", objectFit: "cover", width: "100%" }}
                  onClick={() => navigate("/product/" + item?._id)}
                   onError={(e) => {
    e.target.onerror = null;
    e.target.src =item.images[i+1].url;
  }}
                />
              )
          )}
        </div>

        {/* Product Details */}
        <div className="product-details">
          <h6 className="brand">{off}% off</h6>
          <h5 className="product-title h-auto d-none d-md-block">{item?.title?.substr(0, 35)}...</h5>
          <h5 className="product-title h-auto d-block d-md-none">{item?.title?.substr(0, 16)}...</h5>

          <div className="star-rating d-none d-md-block">
            <ReactStars
              count={5}
              size={24}
              value={item?.totalrating}
              edit={false}
              activeColor="#ffd700"
            />
          </div>

          <p className="d-flex align-items-center gap-2 mb-1 text-nowrap">
            <del className="text-muted small">{symbole}{item?.price}</del>
            <span className="fw-semibold">{symbole}{item?.current_price}</span>
          </p>

          {/* Size, Color, Quantity: hidden until Buy Now clicked */}
         {showOptions && (<ModalPortal>
  <div className="product-modal-backdrop" onClick={() => setShowOptions(false)}>
    <div
      className="product-modal"
      onClick={(e) => e.stopPropagation()} // prevent close on inner click
    >
      <h5 className="mb-3 text-center fw-bold">Select Options</h5>

      {/* Size */}
      {sizes.length > 0 && (
        <div className="mb-3">
          <p className="fw-semibold mb-2">Size</p>
          <div className="d-flex flex-wrap gap-2">
            {sizes.map((size) => (
              <div
                key={size}
                className={`size-option ${
                  selectedSize === size ? "active" : ""
                }`}
                onClick={() => setSelectedSize(size)}
              >
                {size}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Color */}
      {colors.length > 0 && (
        <div className="mb-3">
          <p className="fw-semibold mb-2">Color</p>
          <div className="d-flex gap-2 flex-wrap">
            {colors.map((color) => (
              <div
                key={color._id}
                className={`color-option ${
                  selectedColor === color._id ? "active" : ""
                }`}
                style={{ backgroundColor: color.title || "#000" }}
                onClick={() => setSelectedColor(color._id)}
              />
            ))}
          </div>
        </div>
      )}

      {/* Quantity */}
      <div className="mb-3">
        <p className="fw-semibold mb-2">Quantity</p>
        <div className="d-flex align-items-center gap-3">
          <button
            className="qty-btn"
            onClick={() => setQuantity((q) => Math.max(1, q - 1))}
          >
            −
          </button>
          <span className="fw-semibold">{quantity}</span>
          <button
            className="qty-btn"
            onClick={() => setQuantity((q) => Math.min(maxQty, q + 1))}
          >
            +
          </button>
        </div>
      </div>

      {/* Validation */}
      {((sizes.length > 0 && !selectedSize) ||
        (colors.length > 0 && !selectedColor)) && (
        <p className="text-danger small mb-2">
          Please select all required options
        </p>
      )}

      {/* Actions */}
      <div className="d-flex gap-2 mt-3">
        <button
          className="btn btn-outline-secondary w-50"
          onClick={() => setShowOptions(false)}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary w-50"
          onClick={handleProceed}
        >
          Proceed
        </button>
      </div>
    </div>
  </div>
  </ModalPortal>
)}

        </div>

        {/* Buy Now */}
        <div className="top-50 cart-button d-block">
          <button
            className="text-white d-flex justify-content-center align-items-center"
            style={{ background: "#0053e2", borderRadius: "9px", border: "0 none", fontSize: "12px", minHeight: "auto" }}
            onClick={handleBuyNow}
          >
            <img src={cart} alt="addcart" className="me-1" style={{ width: "10%", height: "10%" }} />
            <span className="d-none d-sm-inline">Buy Now</span>
            <span className="d-sm-none">Buy Now</span>
          </button>
        </div>

        {/* Action Bar */}
        <div className="action-bar position-absolute my-0">
          <div className="d-flex flex-column gap-1">
               <button className="border-0 bg-light text-link m-2" style={{
              // width:"10px",
              // height:"10px",
              // padding:"1px",
              borderRadius:"30px",
              minHeight:"30px",
              minWidth:"30px"
            }}>
            <img
              src={wish}
              alt="wishlist"
              className="mx-auto"
              onClick={() => addToWish(item?._id)}
            />
          </button>
            <button className="border-0 bg-light text-link m-2" style={{
             
              borderRadius:"30px",
              minHeight:"30px",
              minWidth:"30px"
            }}>
              <img
               className="mx-auto"
                onClick={() => navigate("/product/" + item?._id)}
                src={view}
                alt="view"
              />
            </button>
            <button className="border-0 bg-light text-link m-2" style={{
         
              borderRadius:"30px",
              minHeight:"30px",
              minWidth:"30px"
            }} onClick={() => addcart(item)}>
              <img src={cart} alt="addcart"  className="mx-auto" style={{
              height:"20px",
                width:"20px"
              }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCardCommon;
